<template>
  <main class="page-main">
    <News />
    <Cars />
    <Servis />
    <About />
    <Contacts />
  </main>
</template>
<script>
// Části stránky
import About from "./About/About";
import Servis from "./Servis/Servis";
import Contacts from "./Contacts/Contacts";
import Cars from "./Cars/Cars";
import News from "./News/News";

export default {
  components: {
    About,
    Cars,
    Servis,
    Contacts,
    News
  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/global.scss";

.page-main {
  background-color: #fff;
  z-index: 5;
  width: 100vw;
  margin-top: 4rem;
}
@media (min-width: $min-width-extended) {
  .page-main {
    margin-top: 26rem;
  }
}
</style>
